import { useIntl } from '@alltrails/shared/react-intl';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
import User from '@alltrails/shared/types/User';
import CustomProvider from 'components/CustomProvider';
import AlgoliaSearchBox from './AlgoliaSearchBox';

type AlgoliaSearchBoxProps = {
  algoliaIndexId: string;
  className?: string;
  currentUser: User;
  defaultLatLng: any;
  languageRegionCode: LanguageRegionCode;
  mobileBrowser: boolean;
  onLocationPage: boolean;
  page: string;
};
const AlgoliaSearchBoxErbWrapper = ({
  algoliaIndexId,
  className,
  currentUser,
  defaultLatLng,
  languageRegionCode,
  mobileBrowser,
  onLocationPage,
  page
}: AlgoliaSearchBoxProps) => {
  return (
    <CustomProvider>
      <AlgoliaSearchContainer
        algoliaIndexId={algoliaIndexId}
        className={className}
        currentUser={currentUser}
        defaultLatLng={defaultLatLng}
        languageRegionCode={languageRegionCode}
        mobileBrowser={mobileBrowser}
        onLocationPage={onLocationPage}
        page={page}
      />
    </CustomProvider>
  );
};

const AlgoliaSearchContainer = (props: AlgoliaSearchBoxProps) => {
  const intl = useIntl();

  return <AlgoliaSearchBox {...props} intl={intl} />;
};

export default AlgoliaSearchBoxErbWrapper;
